import "./style.less";

// TO DO ::: MEDIUM ::: ApiV3 - BpCancelationModal has no implementation test yet!
export default function BpCancelationModal(
    bp,
    color,
    $scope,
    $q,
    moment,
    $element,
    Bookings,
    BookingPeriods,
    close,
    Log,
    $timeout
) {
    $scope.color = color;
    $scope.termsAccepted = false;
    $scope.mustApproveDialog = false;
    $scope.isLoading = false;

    let bpWasCancelled = false;

    $scope.notifications = {
        error: null,
        success: null,
    };

    const isCancellationAllowed = (cancellationbeforehour, bpStart) => {
        const overdueMoment = moment(bpStart).add(
            -cancellationbeforehour,
            "hours"
        );

        // //  is moment later than overdueMoment
        // console.log(moment() < overdueMoment);

        return moment() < overdueMoment;
    };

    const cancellationAllowed = isCancellationAllowed(
        bp.activity.cancellationbeforehour,
        bp.start
    );

    if (!cancellationAllowed) {
        $scope.notifications.error = "Din annulleringsfrist er overskredet.";
    }

    const eSum = (bpEntries) => {
        // var total = 0; // reset and recalculate total price
        let total = 0;

        bpEntries.forEach((bpe) => {
            total += bpe.price * bpe.amount;
        });

        return total;
    };

    const entriesSum = bp.bookingPeriodEntries
        ? eSum(bp.bookingPeriodEntries)
        : 0;

    $scope.totalPrice = bp.price + entriesSum;

    // $scope.notifications.error =
    //     "Der er opstået en fejl.. <br>Kontakt venligst Københavns kommune for at annullere din booking.";

    // $scope.notifications.success =
    //     "Din booking er annulleret. Vi har sendt dig en email.";

    $scope.confirmCancelation = function ($event, bp) {
        if ($scope.termsAccepted) {
            /**
             *  // cancel bp api flow:
             *  1 . Set status to cancel: (send hele modellen)
             */

            $scope.isLoading = true;
            // Set timeout to prevent bulk cancellation and lock up DB
            $timeout(function () {
                cancelBpApi(bp).then(
                    (res) => {
                        // SUCCESSS
                        $scope.notifications.success =
                            "Din booking er annulleret. Vi har sendt dig en email.";

                        bpWasCancelled = true;

                        $scope.isLoading = true;
                    },
                    (err) => {
                        console.warn(err);
                        $scope.notifications.error =
                            "Der er opstået en fejl.. <br>Kontakt venligst Københavns kommune for at annullere din booking.";

                        bpWasCancelled = false;

                        $scope.isLoading = false;
                    }
                );
            }, 5000);
        }
    };

    const cancelBpApi = () => {
        /**
         * 2. Change bp.status to 4 (Cancelled)
         */
        bp.statusId = 4;

        // remove extended properties
        delete bp.booking._status;

        /**
         * 1 Set status to cancel:
         */
        return Bookings.updateBookingPeriod(bp).then(
            (res) => {
                const updatedBp = res.data;

                // console.log(updatedBp.bookingId + "!==" + bp.bookingId);

                if (updatedBp.bookingId !== bp.bookingId) {
                    return $q.reject("API returned the wrong booking (id)");
                }

                /**
                 * 2. Complete cancel action + send mail:
                 * NOTE: /cancelBooking will only cancel bp's which has a status of 4.
                 * Not the entire booking!
                 */

                return Bookings.cancelBooking(bp.bookingId).then(
                    (res) => {
                        return res.data.success
                            ? $q.resolve("success: " + res.message)
                            : $q.reject(
                                  "API there was an error trying to update the booking : " +
                                      res.message
                              );
                    },
                    (err) => {
                        return $q.reject(
                            "API there was an error.. possibly with payment refund " +
                                res.message
                        );
                    }
                );
            },
            (err) => {
                return $q.reject(
                    "API there was an error trying top update the booking : " +
                        res.message
                );
            }
        );
    };

    $scope.modalClose = function (bp) {
        $element.modal("hide");

        close(
            {
                bp: bp,
                bpWasCancelled: bpWasCancelled,
            },
            500
        ); // close, but give 500ms for bootstrap to animate
    };

    // const isCancellation = true;
    // $scope.modalClose(isCancellation);

    $scope.getCancellationInfo = function (bp) {
        BookingPeriods.get(bp.id).then((res) => {
            Log.string("GET BOOKING PERIOD INFO");

            $scope.bp = { ...res, ...bp };

            $scope.cancelBookingInfo = res;
        });

        // bookingService.getCancellationInfo(bookingID).then(function (response) {
        //     $scope.cancelBookingInfo = response;
        // });
    };

    $scope.toggleAcceptTerms = function () {
        $scope.termsAccepted = $scope.termsAccepted ? false : true;

        if ($scope.termsAccepted) {
            $scope.mustApproveDialog = false;
        }
    };

    // call it
    $scope.getCancellationInfo(bp);
}
